import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles({
  heading: {
    fontSize: 26,
    color: '#000',
    fontWeight: 700,
    lineHeight: 1.5,
    marginBottom: 40,
  },
  preview: {
    maxWidth: 455,
    padding: 30,
    margin: '0 auto 67px',
    textAlign: 'left',
    border: '1px solid rgba(15, 13, 35, 0.2)',
    borderRadius: 15,
    boxShadow: '2px 3px 10px #7777771A',
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:not(:last-child)': {
      marginBottom: 19,
    },
  },
  text: {
    fontSize: 22,
    color: '#000',
  },
  textMedium: {
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  textMuted: {
    color: '#5f5f5f',
    textTransform: 'uppercase',
  },
  divider: {
    width: 118,
    height: 1,
    backgroundColor: '#cfced3',
    margin: '24px 0 18px auto',
  },
  button: {
    borderRadius: 13,
    boxShadow: '0 3px 13px #c6e5ff',
    padding: '12px 16px',
  },
  buttonLabel: {
    fontSize: 19,
    fontWeight: 600,
    textTransform: 'none',
  },
});
